import { PropsWithChildren } from 'react';
import { useMediaQuery } from 'react-responsive';
import styled, { useTheme } from 'styled-components';

import { Modal } from 'app/theme/Modal';
import { breakpoint } from 'app/theme/theme';
import { CloseDialogIcon } from 'pkg/components/CloseDialogIcon';

const DialogContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  ${breakpoint.up.sm`
    flex-direction: row;
  `}
`;

const PartOfDialog = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  ${breakpoint.up.sm`
    justify-content: center;
    width: 47%;
  `}
`;

const PartWithInformation = styled(PartOfDialog)`
  ${breakpoint.up.sm`
    justify-content: flex-start;    
    width: 53%;
  `}
`;

const StyledModal = styled(Modal)`
  overflow: visible;
  &&& {
    width: calc(100% - 6rem);
    padding: 2.5rem 1.5rem 3rem 1.5rem;
    background: linear-gradient(270deg, #b0b0b0 0%, #fdfdfd 100%);
    box-shadow: 1rem 1.4rem 4.4rem rgba(0, 0, 0, 0.45);
    border-radius: 0.5rem;
    ${breakpoint.up.sm`      
      padding: 0;
      height: 80rem;
      border-radius: 1rem;
    `}
    ${breakpoint.up.md`
      height: 90rem;
      max-width: 110rem;
    `}
  }
`;

interface DialogWithImageProps {
  image: JSX.Element;
  onClose?: () => void;
}

export const DialogWithImage = ({ image, onClose, children }: PropsWithChildren<DialogWithImageProps>): JSX.Element => {
  const { breakpoints } = useTheme();
  const isDesktop = useMediaQuery({ query: `(min-width: ${breakpoints.values.md}px` });

  return (
    <StyledModal closeOnDimmerClick={isDesktop} closeIcon={<CloseDialogIcon />} size="large" onClose={onClose} open>
      <DialogContent>
        <PartOfDialog>{image}</PartOfDialog>
        <PartWithInformation>{children}</PartWithInformation>
      </DialogContent>
    </StyledModal>
  );
};
